import { render, staticRenderFns } from "./VisualizarTriagem.vue?vue&type=template&id=858e245c&"
import script from "./VisualizarTriagem.vue?vue&type=script&lang=js&"
export * from "./VisualizarTriagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports